export const ACTION_CODE_SAVEFORLATER:string = 'SAVEFORLATER';
export const ACTION_CODE_GOTOSUBMIT:string = 'GOTOSUBMIT';
export const ACTION_CODE_SUBMIT:string = 'SUBMIT';
export const ACTION_CODE_CANCEL:string = 'CANCEL';